import React, {
  useState
} from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import {
  createPack,
  showPack,
} from '~/config/routes';
import Request from '~/providers/Request';
import PackRecord from '~/records/PackRecord';
import Form from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new PackRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();

    Request.post('/admin/packs', data, {}, { controller: 'packs' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(createPack.spec);
        } else {
          history.push(showPack.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
